import axios from "axios";
import { getTokenToLocalStorage } from "./local-storage";

const URL = process.env.REACT_APP_BASE;
const URL_GR = process.env.REACT_APP_GR_API;
const URL_ANTARES = process.env.REACT_APP_ANTARES_API;
const ANTARES_KEY = process.env.REACT_APP_ANTARES_KEY;

export const Api = axios.create({ baseURL: URL_GR });
const ApiBiometria = axios.create({ baseURL: URL });
export const ApiAntares = axios.create({ baseURL: URL_ANTARES });

ApiBiometria.interceptors.request.use(async (config) => {
  const token = getTokenToLocalStorage() || null;
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

ApiAntares.interceptors.request.use(async (config) => {
  config.headers["User-Api-Key"] = `${ANTARES_KEY}`;

  return config;
});

export default ApiBiometria;
